/* tslint:disable:max-line-length */
import {Injectable, OnDestroy} from '@angular/core';
import {AttachmentDataLoaderService} from '@docma-mm-core/attachment/attachment-data-loader.service';
import {LoadState} from '@docma-mm-core/model/load-state/load-state';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {Activity, ActivityData} from './activity';
import {Fault} from '@docma-mm-core/fault/fault';

@Injectable()
export class ActivityDataLoaderService implements OnDestroy {


  constructor(private readonly attachmentLoaderService: AttachmentDataLoaderService) {

  }

  ngOnDestroy(): void {
  }


  public deepLoadFromData(fault: Fault, activity: Activity, fullActivityData: ActivityData, loadDate?: Date): Activity {
    loadDate = loadDate ?? new Date(Date.now());
    const activityData = {...fullActivityData};
    delete activityData.Files;
    const activityState = new LoadState({date: loadDate, data: activityData, status: LoadStatusEnum.Loaded});
    activity.loadState = activityState;
    const attachments = activity.attachments ?? [];
    activity.attachments = [];
    this.attachmentLoaderService.mergeWithLoadData(attachments,  fullActivityData.Files ?? [])
    .forEach(a => {
      activity.addAttachment(a.attachment);
      // fault.addScribbles(a.scribbles);
    });

    if (fullActivityData.Group) {
      activity.group =  { id: fullActivityData.Group.Id, uid: fullActivityData.Group.UniqueId };
    }

    return activity;
  }

   public mergeWithLoadData(fault: Fault, activities: Array<Activity>, loadData: Array<ActivityData>, loadDate?: Date, mergeExisting: boolean = false): Array<Activity> {
    loadDate = loadDate ?? new Date(Date.now());
    const existingActivities = activities || [];
    const loadActivitiesData = [...loadData];

    const mergedActivities: Array<Activity> = [];

    existingActivities.forEach(oa => {
      if (oa.isNew || mergeExisting) {
        mergedActivities.push(oa);
      } else {
        const found = loadActivitiesData.find(a => a.Id === oa.id);
        if (found) {

          mergedActivities.push(this.deepLoadFromData(fault, oa, found, loadDate));
        }
      }
    });

    loadActivitiesData.forEach(ad => {
      if (!mergedActivities.find(ma => ma.id === ad.Id)) {

        mergedActivities.push(this.deepLoadFromData(fault, new Activity(), ad, loadDate));
      }
    });

    return mergedActivities.sort((a, b) => {
      const d1 = a.data.Date != null ? new Date(a.data.Date).getTime() : 0;
      const d2 = b.data.Date != null ? new Date(b.data.Date).getTime() : 0;
      return d2 - d1;
    });

  }

}
